import { isEmpty } from 'lodash-es';
import { useState, useEffect, Dispatch, SetStateAction } from 'react';
import {
  candidateSearchAdvancedQuery,
  IJobCandidateInteraction,
  ICandidate,
  getCandidatesRecentSubmissions,
  ICandidateRecentConversation,
  getCandidateSearch,
  mappedCandidateSearchAdvancedQuery,
} from 'wisestep-api';

import { paginationSettingsStore } from '../../../utils/PaginationSettingStore';
import { useConversationWidgetStore } from '../../../utils/useConversationWidgetStore';

interface IListingCandidates {
  list: (ICandidate & { isSelected: boolean })[];
  pagesCount: number;
  stageStatus: ICandidateRecentConversation[];
  isError: boolean;
  totalElements?: number;
}

const useListingCandidates = (
  query: IJobCandidateInteraction,
  setLoader: Dispatch<SetStateAction<boolean>>,
  type: 'submissions' | 'candidate' | 'jobCRM'
): IListingCandidates => {
  const paginationData = paginationSettingsStore((state) => state.getPaginationSettings);
  const paginationSettings = paginationData();
  const [state, setState] = useState<IListingCandidates>({
    list: [],
    pagesCount: 0,
    totalElements: 0,
    stageStatus: [],
    isError: false,
  });

  // const pageSettings = usePaginationSettings();
  if (type === 'submissions')
    query.size = Number(paginationSettings.submittedCandidatesPagination ?? 50);
  else if (type === 'candidate') query.size = Number(paginationSettings.candidatePagination ?? 50);
  else if (type === 'jobCRM') query.size = Number(paginationSettings?.jobCrmPagination ?? 50);

  const setSearchQuery = useConversationWidgetStore((state) => state.setSearchQuery);
  useEffect(() => {
    const fetchCandidates = async () => {
      try {
        let response;
        if (query) {
          setLoader(true);
          if (type === 'jobCRM') {
            if (
              query.candidateSearchType == 'OnlyMappings' &&
              ((query.jobIds && query.jobIds?.length > 0) || !isEmpty(query.jobId))
            ) {
              response = await mappedCandidateSearchAdvancedQuery({ ...query });
            } else if (query.candidateSearchType == 'OnlySubmissions') {
              response = await candidateSearchAdvancedQuery({ ...query });
            } else {
              response = await getCandidateSearch({ ...query }, true);
            }
          } else {
            if ((query.jobIds && query.jobIds?.length > 0) || !isEmpty(query.jobId)) {
              response = await candidateSearchAdvancedQuery({ ...query });
            } else {
              console.log('JOB_ID', query.jobId, query.jobIds);
            }
          }
          const actionFilters = (query?.recruiterActions ?? []).concat(
            query?.candidateResponses ?? []
          );
          setSearchQuery(
            `${query.query ?? ''}${actionFilters?.map((title) => JSON.stringify(title))?.join(' ')}`
          );
          setLoader(false);
          const candidates = response.data?.content;
          if (candidates) {
            setState((prev) => ({
              ...prev,
              pagesCount: Number(response.data?.totalPages),
              totalElements: Number(response.data?.totalElements),
              list: candidates,
              isError: false,
            }));

            if (type !== 'submissions') {
              const candidatesEntities = candidates.map((item) => ({
                email: item.email,
                profileUrls: item.profileURLs,
              }));
              const interactions = await getCandidatesRecentSubmissions(candidatesEntities).catch(
                (e) => {
                  console.log(e);
                }
              );
              setState((prev) => ({
                ...prev,
                stageStatus: interactions?.data ?? [],
              }));
            }
          }
        }
      } catch (e) {
        setState((m) => ({ ...m, list: [], pagesCount: 0, isError: true }));
        setLoader(false);
      }
    };

    fetchCandidates();
  }, [setLoader, setSearchQuery, query, type]);
  return state;
};

export default useListingCandidates;
